/**
 * IMPORTS
 */

import { useQuery } from "@tanstack/react-query";

import { IModeloTecnicoResponse } from "@/hooks/modelos/buscar-modelo-unico-por-cliente/interface";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleGetModeloUnicoDoCliente } from "@/domain/use-cases/modelos";

function useBuscarModeloUnicoPorCliente(modelo_id: number) {
  const { token: accessToken } = useStoreZustandUserAuth();

  // chave por modelo: sem o id, todos os modelos compartilhariam a mesma entrada de cache
  const queryKey = ["modelos-unico", modelo_id];

  const {
    isLoading,
    error: isError,
    data: modelosResponse,
  } = useQuery<IModeloTecnicoResponse>({
    queryKey,
    queryFn: async () => {
      const currentPage = 1;
      const itemsPerPage = 10;
      const searchItem = "";

      const response = await handleGetModeloUnicoDoCliente(
        accessToken!,
        modelo_id,
        currentPage,
        itemsPerPage,
        searchItem
      );
      return response;
    },
    enabled: !!accessToken && modelo_id !== 0, // evita execução desnecessária
  });

  const modelos = modelosResponse?.data;

  return {
    modeloUnico: modelos ?? null,
    isLoading,
    isError,
  };
}

/**
 * EXPORTS
 */
export { useBuscarModeloUnicoPorCliente };
